import {onFind} from "@elements/init-modules-in-scope";
import {find, removeClass} from '@elements/dom-utils';

const isMobile = () => matchMedia('(max-width: 767px)').matches;

export function init () {
    if(isMobile()){
        onFind('.js-collapse-mobile__btn', function (btn) {
            let id = btn.getAttribute('data-bs-target')
            let overlay = find(id);
            removeClass('show', overlay);
        });
    }
}
